import {
  Button,
  Modal,
  ModalControlsStyled,
  StyledHeader,
} from '@clickcease/cc-client-components-lib'
import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import {
  CrossSellPricingConfirmationModalDescription,
  CrossSellPricingConfirmationModalNotice,
  CrossSellPricingConfirmationModalStyled,
} from 'Features/CrossSell/CrosSellPricing/CrossSellPricingConfirmationModal/CrossSellPricingConfirmationModal.styled'
import { MODIFY_PLANS_PAGES_TYPES, ModifyPlansPagesTypes } from 'Types/ModifyPlanPagesTypes'
import { useIsTrialSubscription } from 'Hooks/trial/useIsTrialSubscription'

type ConfirmationModalProps = {
  title: string
  pageType: ModifyPlansPagesTypes
  description: string
  notice?: string
  isPlanCanceled?: boolean
  error?: string | ReactNode
  isLoading?: boolean
  isProductTrialAllowed?: boolean
  onOpenChange: () => void
  onClose: () => void
  updatePlan: () => void
}

export const OldConfirmationModal = ({
  title,
  pageType,
  description,
  notice,
  isPlanCanceled,
  error,
  isLoading,
  isProductTrialAllowed,
  onOpenChange,
  onClose,
  updatePlan,
}: ConfirmationModalProps) => {
  const { t } = useTranslation('pricing')
  const isTrialSubscription = useIsTrialSubscription()

  const buttonText = t(
    `cross-sell.cross_sale_pricing.${
      isProductTrialAllowed
        ? 'confirmation_modal_cta_trial'
        : isTrialSubscription
        ? 'add_to_trial'
        : 'upgrade_plan'
    }`
  )
  return (
    <Modal title={title} isOpen={true} onOpenChange={onOpenChange} onCloseClick={() => {}}>
      <CrossSellPricingConfirmationModalStyled>
        <CrossSellPricingConfirmationModalDescription
          modifyPlan={pageType === MODIFY_PLANS_PAGES_TYPES.MODIFY_PLAN}
          canceledPlan={isPlanCanceled}
        >
          {description}
          {isPlanCanceled && (
            <StyledHeader variant={'h3'} css={{ marginTop: '$4' }}>
              {t('modify_plan.cancellation_revoke')}
            </StyledHeader>
          )}
        </CrossSellPricingConfirmationModalDescription>
        {notice && (
          <CrossSellPricingConfirmationModalNotice>
            {notice}
          </CrossSellPricingConfirmationModalNotice>
        )}
        {error && error}
        <ModalControlsStyled>
          {!isProductTrialAllowed && (
            <Button
              variant="ghost"
              text={t('cross-sell.cross_sale_pricing.cancel')}
              onClick={onClose}
            />
          )}

          <Button disabled={isLoading} loading={isLoading} text={buttonText} onClick={updatePlan} />
        </ModalControlsStyled>
      </CrossSellPricingConfirmationModalStyled>
    </Modal>
  )
}
